<div [hidden]="(stepNumber > activeStep) || hidden" class="card px-0" [class.disabled-mask]="activeStep > stepNumber">
  <div class="card-body pb-2 mb-0">
    <ng-content />
    <div class="pt-3">
      @if (showBackButton()) {
        <button pButton pRipple type="button" [label]="backButtonLabel()"
        class="p-button-secondary float-left mt-3 px-3" (click)="back()"></button>
      }
      @if (showNextButton()) {
        <button pButton pRipple type="button" [label]="nextButtonLabel()"
          [class]="'float-right mt-3 px-3 ' + nextButtonClass()" (click)="next()" [disabled]="!nextButtonEnabled()"
        [class.w-100]="!showBackButton()"></button>
      }
    </div>
  </div>
</div>